import React from 'react'
import {
  MetaParamsNotice,
  MetaParamsTabStyled,
  MetaParamsText,
  Step,
  StepsList,
  StepTwoText,
  StepThreeText,
  ToAddTracking,
} from 'Features/CheqParamsModal/Tabs/Meta/MetaParamsTab.styled'
import { CodeWrapper } from 'Features/CheqParamsModal/CheqParamsModal.styled'
import { Trans, useTranslation } from 'react-i18next'
import { FlexColumn } from 'Providers/app.styled'
import { OutsideLink, CopyTextButton, InfoCircled } from '@clickcease/cc-client-components-lib'

export const MetaParamsTab = () => {
  const { t } = useTranslation('domainManagement')

  const code1 = 'cq_net={{ site_source_name }}&cq_plt=fp'
  const code2 =
    'cq_src=facebook&cq_cmp={{campaign.name}}&cq_con={{ad.name}}&cq_med={{placement}}&cq_net={{site_source_name}}&cq_plt=fp'
  const metaHelpCenterUrl =
    'https://www.facebook.com/business/help/112167992830700?id=561906377587030'
  const learnMoreUrl = 'https://www.facebook.com/business/help/1016122818401732'

  return (
    <MetaParamsTabStyled>
      <MetaParamsNotice>
        <InfoCircled />
        <MetaParamsText>
          <Trans ns="domainManagement" i18nKey="tracking_params_modal.facebook_tab.notice_text">
            Metas review process will temporarily send your ads into the learning phase following
            the tracking parameters addition. For more information visit
            <OutsideLink target={'_blank'} href={metaHelpCenterUrl}>
              Metas help center
            </OutsideLink>
          </Trans>
        </MetaParamsText>
      </MetaParamsNotice>

      <ToAddTracking>
        <Trans ns="domainManagement" i18nKey="tracking_params_modal.facebook_tab.to_add_tracking">
          To add tracking parameters on Meta, update your ads URL parameters.
          <OutsideLink target={'_blank'} href={learnMoreUrl}>
            Learn more
          </OutsideLink>
        </Trans>
      </ToAddTracking>
      <StepsList>
        <Step>{t('tracking_params_modal.facebook_tab.first_bullet')}</Step>
        <Step>
          <FlexColumn>
            <StepTwoText>
              <Trans
                ns="domainManagement"
                i18nKey="tracking_params_modal.facebook_tab.second_bullet"
              >
                If <b>only</b> utm_source and utm_campaign exist, add the following to the UTM
                structure
              </Trans>
            </StepTwoText>
            <CodeWrapper>{code1}</CodeWrapper>
            <CopyTextButton buttonText={t('tracking_params_modal.copy')} value={code1} />
          </FlexColumn>
        </Step>
        <Step>
          <FlexColumn>
            <StepThreeText>{t('tracking_params_modal.facebook_tab.third_bullet')}</StepThreeText>
            <CodeWrapper>{code2}</CodeWrapper>
            <CopyTextButton buttonText={t('tracking_params_modal.copy')} value={code2} />
          </FlexColumn>
        </Step>
      </StepsList>
    </MetaParamsTabStyled>
  )
}
